import axios, { AxiosInstance } from "axios";
import store from "../../store";
import { setSnackbarDetails } from "../../Redux/AuthSlice";

export const apiAxios: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

apiAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("vcuUserAccessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

let isHandling401 = false;

apiAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isHandling401) {
      isHandling401 = true;

      // ✅ Show snackbar
      store.dispatch(
        setSnackbarDetails({
          status: true,
          message: "Unauthorized access. Please login again.",
          severity: "error",
        }),
      );

      // ✅ Clear tokens
      localStorage.removeItem("vcuUserAccessToken");
      localStorage.removeItem("fitbit_access_token");
      localStorage.removeItem("fitbit_refresh_token");
      localStorage.removeItem("fitbit_expiry");

      // ✅ Delay redirect (so snackbar is visible)
      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
    }

    return Promise.reject(error);
  },
);
